// extracted by mini-css-extract-plugin
export default {"root":"SummerSaleButtonAnimation__root--1v0d6","rootMobile":"SummerSaleButtonAnimation__rootMobile--3DBXU"};